export { ReactComponent as TextDirectionLTR } from './svgs/text-direction-ltr.svg';
